import { RootState } from "../store";

export const selectSelectedOperator = (state: RootState) =>
  state.operator.selectedOperator;
export const selectSelectedPlan = (state: RootState) =>
  state.operator.selectedPlan;
export const selectPhoneDetails = (state: RootState) =>
  state.operator.phoneDetails;
export const selectOperators = (state: RootState) => state.operator.operators;
export const selectOperatorsLoading = (state: RootState) =>
  state.operator.operatorsLoading;
export const selectOperatorsError = (state: RootState) =>
  state.operator.operatorsError;
